import { useTranslation } from 'react-i18next';

/** Індикатор завантаження: кільце 18px з акцентною дугою; для читачів екрана — «Завантаження…». */
export function Spinner() {
  const { t } = useTranslation();
  return <span className="spinner" role="status" aria-label={t('app.loading')} />;
}
